import {
  Box,
  Collapse,
  IconButton,
  Paper,
  Typography
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CloseIcon from "@material-ui/icons/Close";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { ChipStatus } from "components/ChipStatus";
import { CustomLineProgress } from "components/LineProgress";
import { useState } from "react";
import { BiMessageAltDetail } from "react-icons/bi";
import { FaEllipsisV } from "react-icons/fa";
import { MdOutlineSearchOff } from "react-icons/md";
import { MenuPopover } from "shared";

import { receiptConferenceStyles, rowConferenceStyles } from "./styles";

const Row = ({ row, childrenColumns, index, setConferenceData, loading }) => {
  const { conferences, seller, receiptDate } = row;

  const [anchorEl, setAnchorEl] = useState(null);
  const [observationPopup, setObservationPopup] = useState(false);
  const [openObservationPopup, setOpenObservationPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const classes = rowConferenceStyles({ index });

  const handleOpenPopover = (event, observation) => {
    setOpenObservationPopup(true);
    setObservationPopup(observation);
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenObservationPopup(false);
    setObservationPopup("");
    setAnchorEl(null);
  };

  return (
    <>
      <MenuPopover
        open={openObservationPopup}
        onClose={handleClosePopover}
        anchorEl={anchorEl}
      >
        <Box className={classes.menuPopover}>
          <Typography className={classes.observationText}>
            {observationPopup}
          </Typography>

          <Box className={classes.popoverAction}>
            <IconButton onClick={handleClosePopover}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </MenuPopover>

      <TableRow
        className={classes.root}
        style={open ? { background: "#E5ECD1" } : null}
      >
        <TableCell className={classes.sellerName}>{seller?.name}</TableCell>
        <TableCell className={classes.sellerName}>{receiptDate}</TableCell>
        <TableCell align="right">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCell} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <div style={{ overflowX: "auto", maxWidth: "100%" }}>
              <Box margin={1}>
                <Table
                  size="small"
                  aria-label="purchases"
                  style={{ minWidth: "800px" }}
                >
                  <TableHead>
                    <TableRow>
                      {childrenColumns.map(column => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          className={classes.subtitle}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {conferences.map(conference => (
                      <TableRow
                        className={classes.tableRow}
                        key={conference.batchConferenceId}
                      >
                        <TableCell className={classes.producName} align="left">
                          {conference.batchInfos?.product.name}
                        </TableCell>
                        <TableCell
                          className={classes.producName}
                          align="center"
                        >
                          {conference.receiptTime}
                        </TableCell>
                        <TableCell
                          className={classes.producName}
                          align="center"
                        >
                          {conference.forecast}
                        </TableCell>
                        <TableCell
                          className={classes.producName}
                          align="center"
                        >
                          {conference.batchInfos?.quantity}
                        </TableCell>
                        <TableCell
                          className={classes.producName}
                          align="center"
                        >
                          {conference.quantityInvoice}
                        </TableCell>
                        <TableCell
                          className={classes.producName}
                          align="center"
                        >
                          {conference.invoiceNumber ||
                            conference.invoice_number ||
                            "-"}
                        </TableCell>
                        <TableCell align="center">
                          {conference.observation && (
                            <BiMessageAltDetail
                              size="1.7rem"
                              color="#6C8932"
                              onClick={event =>
                                handleOpenPopover(event, conference.observation)
                              }
                              className={classes.iconDesign}
                            />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <ChipStatus
                            label={conference.status?.name}
                            statusId={conference.status?.id === 1 ? 3 : 2}
                          />
                        </TableCell>
                        <TableCell align="right">
                          <FaEllipsisV
                            size="1.2rem"
                            color="#757575"
                            onClick={() => setConferenceData({ ...conference })}
                            className={classes.iconDesign}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </div>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export const ReceiptConferenceTable = ({
  columns,
  childrenColumns,
  data,
  setConferenceData,
  loading
}) => {
  const classes = receiptConferenceStyles();
  const hasData = data && data.length > 0;

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            {columns.map((column, index) => (
              <TableCell
                key={index}
                align={column.align}
                className={classes.title}
              >
                {column.label}
              </TableCell>
            ))}
            <TableCell />
          </TableRow>
          {loading && (
            <TableRow>
              <TableCell colSpan={columns.length + 1} style={{ padding: 0 }}>
                <CustomLineProgress />
              </TableCell>
            </TableRow>
          )}
        </TableHead>
        <TableBody>
          {!loading && !hasData ? (
            <TableRow>
              <TableCell
                colSpan={columns.length + 1}
                style={{
                  textAlign: "center",
                  padding: "4rem 2rem",
                  border: "none"
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "2rem"
                  }}
                >
                  <MdOutlineSearchOff
                    style={{
                      fontSize: "4rem",
                      color: "#757575"
                    }}
                  />
                  <Typography
                    style={{
                      fontSize: "1.2rem",
                      color: "#757575",
                      textAlign: "center"
                    }}
                  >
                    Nenhum registro encontrado
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            data.map((seller, index) => (
              <Row
                index={index}
                key={index}
                row={seller}
                childrenColumns={childrenColumns}
                setConferenceData={setConferenceData}
                loading={loading}
              />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
